import React from 'react';
import { Typography } from '@mui/material';
import Icon from '../../../muiComponents/Icon';
import useTranslate from '../../../customHooks/useTranslate';

/**
 * Displays a compact icon and translated message for an empty popover section.
 * @param props The activity section without results.
 * @returns The compact empty state.
 */
const ActivityEmptyState = ({
    section,
}: {
    section: 'notifications' | 'processes';
}) => {
    const translate = useTranslate();
    const isNotifications = section === 'notifications';

    return (
        <div className='activity__empty-state'>
            <div className='activity__empty-state-icon' aria-hidden='true'>
                <Icon iconName='PlaylistAddCheckOutlined' />
            </div>
            <Typography component='h3' variant='subtitle2'>
                {translate('activity_all_clear')}
            </Typography>
            <Typography variant='body2'>
                {translate(
                    isNotifications
                        ? 'activity_no_pending_notifications'
                        : 'activity_no_pending_processes'
                )}
            </Typography>
        </div>
    );
};

export default ActivityEmptyState;
